import { decodeToken } from 'react-jwt';

export function getAdminInfo() {
  const adminInfo = decodeToken(localStorage.getItem('token'));
  return adminInfo;
}

export function validateForm(validation, validationSetter, formData) {
  let isValid = true;
  // Reset every flag first so a field that was flagged on a previous submit
  // (e.g. baptism_date when the parent had toggled 'baptised' to yes) clears
  // once its failure condition no longer applies. One state update at the
  // end, not one per field.
  const nextValidation = {};
  for (const field in validation) {
    nextValidation[field] = false;
  }

  for (const field in validation) {
    if (!formData[field].trim()) {
      // special cases
      // Sacraments are only collected when the parent says the child is baptised.
      if (field === 'baptism_date' && formData['baptised'] !== 'yes') {
        continue;
      }

      if (field === 'session_time') {
        //If level===1, there will be no session_time. skip validation
        if (Number(formData['level']) === 1) {
          break;
        }

        //If transferring from outside, there will be no session_time. skip validation
        if (formData['transfer_from'] !== '') {
          break;
        }
      }

      nextValidation[field] = true;
      isValid = false;
    }
  }

  validationSetter(nextValidation);
  return isValid;
}

export function checkFieldInObject(field, obj) {
  for (const x in obj) {
    if (field === x) {
      return true;
    }
  }
  return false;
}

export function getNumberOfStudentsInSession(sessionId, sessionArray) {
  // iterates the sessionSpread object and obtains the number of students in a given session
  let count = 0;

  sessionArray?.every(session => {
    if (session.student_session_time === sessionId.toString()) {
      count = session.sessionCount;
      return false;
    }
    return true;
  });
  return count;
}

export function getUnassignedStudents(students) {
  let strays = [];
  students?.forEach(student => {
    if (!student.student_session_time || student.student_session_time === '')
      strays.push(student);
  });

  return strays;
}
